import { Navigate, Outlet } from "react-router-dom";
import { useAuthContext } from "../../../contexts/AuthContext";

export const PublicRoute = ({ redirectPath = '/videowall' }) => {
    const sessionToken = localStorage.getItem('token');
    const { user } = useAuthContext();
    const shouldLogin = !!user;

    if (shouldLogin && sessionToken) {
        return <Navigate to={redirectPath} replace />;
    }

    return <Outlet />
}